<template>
  <div id="home">
    <div class="page-shadow">
      <v-touch ref="tapper" v-on:swiperight="prevGround" v-on:swipeleft="nextGround">
        <div class="home">
          <div class="inside products">
            <div class="container clearfix">
              <div class="heading">
                <h2>{{$t('products.headingTopText')}}</h2>
                <span class="text" v-html="$t('products.headingBottomText')"></span>
              </div>
              <div class="boxes">
                <div class="arrows">
                  <div class="arrow arrow-prev" @click="prevGround"></div>
                  <div class="arrow arrow-next" @click="nextGround"></div>
                </div>
                <router-link to="/products/farms" class="box farm-box"
                             v-bind:class="{current : grounds[mobileOption] === 'farm', next : mobileOption < 0, prev : mobileOption > 0}"
                             id="farmGround">
                  <div v-on:mouseover="farmHover" v-on:mouseleave="farmLeave">
                    <div class="area"></div>
                    <div class="icon">
                      <img src="../assets/home/wind-farm.svg" alt="wind-farm"/>
                      <p class="big" v-html="$t('products.farms')"></p>
                    </div>
                  </div>
                  <div class="subtitle">
                        <p>
                          Bioseco BIRD PROTECTION SYSTEM (BPS)
                        </p>
                      </div>
                </router-link>
                <router-link to="/products/airport" class="box big airport-box"
                             v-bind:class="{current : grounds[mobileOption] === 'airport', next : mobileOption < 1, prev : mobileOption > 1}"
                             id="airportGround">
                  <div v-on:mouseover="airportHover" v-on:mouseleave="airportLeave">
                    <div class="area"></div>
                    <div class="icon">
                      <img src="../../static/img/home/airport.svg" alt="airport"/>
                      <p class="big" v-html="$t('products.airports')"></p>
                    </div>
                    <div class="subtitle">
                        <p>
                          Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)
                        </p>
                      </div>
                  </div>
                </router-link>
                <router-link to="/products/area" class="box area-box"
                             v-bind:class="{current : grounds[mobileOption] === 'area' , next : mobileOption < 2, prev : mobileOption > 2}"
                             id="forestGround">
                  <div v-on:mouseover="forestHover" v-on:mouseleave="forestLeave">
                    <div class="area"></div>
                    <div class="icon">
                      <img src="../../static/img/home/area.svg" alt="area"/>
                      <p class="big" v-html="$t('products.area')"></p>
                    </div>
                    <div class="subtitle">
                        <p>
                          Bioseco BIRD PROTECTION SYSTEM (BPS)
                        </p>
                      </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <router-link class="more-about-us" active-class="active" to="/about"><span>{{$t('moreAboutUs')}}</span>
          </router-link>
        </div>
      </v-touch>

      <FooterOrange/>
    </div>
  </div>
</template>

<script>
  import FooterOrange from "../components/FooterOrange";
  import store from "../store/store";

  export default {
    name: "prducts",
    data() {
      return {
        grounds: ["farm", "airport", "area"],
        mobileOption: 1
      };
    },
    mounted: function () {
      store.commit("SHOW_CANVAS");
      store.commit("SHOW_GROUNDS");
      store.commit("SET_MOBILE_ACTIVE", {
        ground: "airport",
        dir: 1
      });
    },
    destroyed() {
      store.commit("HIDE_CANVAS");
    },
    methods: {
      farmHover: function () {
        store.commit("FARM_MOUSE_HOVER");
      },
      farmLeave: function () {
        store.commit("FARM_MOUSE_LEAVE");
      },
      airportHover: function () {
        store.commit("AIRPORT_MOUSE_HOVER");
      },
      airportLeave: function () {
        store.commit("AIRPORT_MOUSE_LEAVE");
      },
      forestHover: function () {
        store.commit("FOREST_MOUSE_HOVER");
      },
      forestLeave: function () {
        store.commit("FOREST_MOUSE_LEAVE");
      },
      nextGround: function () {
        if (window.innerWidth > 780) return;
        this.mobileOption =
          this.mobileOption + 1 >= this.grounds.length
            ? this.mobileOption
            : this.mobileOption + 1;
        store.commit("SET_MOBILE_ACTIVE", {
          ground: this.grounds[this.mobileOption],
          dir: 1
        });
      },
      prevGround: function () {
        if (window.innerWidth > 780) return;
        this.mobileOption =
          this.mobileOption - 1 <= 0 ? 0 : this.mobileOption - 1;
        store.commit("SET_MOBILE_ACTIVE", {
          ground: this.grounds[this.mobileOption],
          dir: -1
        });
      }
    },
    components: {
      FooterOrange
    }
  };
</script>



// WEBPACK FOOTER //
// Products.vue?2e06a9c4